import React from "react"

import style from "./WithRoot.module.css"

const WithRoot = ({ children }) => <div className={style.main}>{children}</div>

export default WithRoot
